<template>
  <b-row
    v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
    class="content-header mb-0"
  >

    <!-- Content Left -->
    <b-col
      class="content-header-left"
      cols="12"
    >
      <b-row class="breadcrumbs-top mb-0">
        <b-col cols="12">
          <h2 class="content-header-title float-left pr-1 mb-0">
            {{ $route.meta.pageTitle }}
          </h2>
          <div class="breadcrumb-wrapper">
            <b-breadcrumb class="breadcrumb-chevron">
              <b-breadcrumb-item to="/">
                <feather-icon
                  icon="HomeIcon"
                  size="16"
                  class="align-text-top"
                />
              </b-breadcrumb-item>
              <b-breadcrumb-item
                v-for="item in $route.meta.breadcrumb"
                :key="item.text"
                :active="item.active"
                :to="item.url"
                @click="onItemClick(item)"
              >
                <div class="d-flex align-items-center">
                  <feather-icon
                    v-if="item.icon"
                    :icon="item.icon"
                    size="16"
                    class="align-text-top mr-50"
                  ></feather-icon>
                  <div v-if="item.extendedTitle">
                    <div class="d-flex flex-row">
                      <span>{{ item.title }}</span>
                      <span class="ml-25 font-weight-bold">
                      {{ item.extendedTitleValue ? item.extendedTitleValue : getSourceItemLabelFromRouterParams() }}
                    </span>
                    </div>
                  </div>
                  <div v-else>
                    {{ item.title }}
                  </div>
                </div>
              </b-breadcrumb-item>
            </b-breadcrumb>
          </div>
        </b-col>
      </b-row>
    </b-col>

    <!-- Content Right -->
    <b-col
      class="content-header-right text-md-right d-md-block d-none mb-1"
      md="3"
      cols="12"
    >
    </b-col>
  </b-row>
</template>

<script>
import {
  BBreadcrumb, BBreadcrumbItem, BRow, BCol, BDropdown, BDropdownItem, BButton, BBadge
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  directives: {
    Ripple,
  },
  components: {
    BBreadcrumb,
    BBreadcrumbItem,
    BRow,
    BCol,
    BDropdown,
    BDropdownItem,
    BButton,
    BBadge
  },
  methods: {
    getSourceItemLabelFromRouterParams() {
      let title = ''
      if (
        this.$route.params && this.$route.params.routerBreadcrumbParams
        && this.$route.params.routerBreadcrumbParams.sourceItemLabel
      ) {
        title = this.$route.params.routerBreadcrumbParams.sourceItemLabel
      }
      if (!title && this.$route.query && this.$route.query.sourceItemLabel) {
        title = this.$route.query.sourceItemLabel
      }
      return title
    },
    onItemClick(item) {
      if (item.targetRoute && item.targetRoute.routeName && item.targetRoute.routeParams) {
        this.$router.push({
          name: item.targetRoute.routeName,
          params: item.targetRoute.routeParams
        })
      }
    }
  },
}
</script>
